module.exports = __webpack_public_path__ + "img/advance-tab.cda7cbac.png";